import React from 'react'
import { toast } from 'react-toastify'
import PropTypes from 'prop-types'
import classNames from 'classnames'

import styles from './CopyField.module.scss'

const CopyField = ({ value, width, name, className }) => {
  const handleClick = (event) => {
    event.target.select()
    document.execCommand('copy')
    toast.success(`${name} copied to clipboard`)
    event.stopPropagation()
  }

  return (
    <input
      type="text"
      style={{ width: `${width}px` }}
      className={classNames(styles.copyField, className)}
      defaultValue={value}
      onClick={handleClick}
    />
  )
}

CopyField.propTypes = {
  value: PropTypes.string.isRequired,
  width: PropTypes.number,
  name: PropTypes.string.isRequired
}

export default CopyField
